import { ReactNode } from 'react'
import { useTranslation } from '../../core/hooks/useTranslation'
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from './Card'
import Button from './Button'
import SaveButton from '../buttons/SaveButton'

interface ModalProps {
  isOpen: boolean
  onClose: () => void
  title: string | ReactNode
  description?: string
  children: ReactNode
  actionButtonText?: string
  onAction?: () => void | Promise<void>
  actionButtonLoading?: boolean
  actionButtonDisabled?: boolean
  actionButtonClassName?: string
  actionButtonLoadingText?: string
  showCancelButton?: boolean
  cancelButtonText?: string
  cancelButtonClassName?: string
}

export default function Modal({
  isOpen,
  onClose,
  title,
  description,
  children,
  actionButtonText,
  onAction,
  actionButtonLoading = false,
  actionButtonDisabled = false,
  actionButtonClassName,
  actionButtonLoadingText,
  showCancelButton = true,
  cancelButtonText,
  cancelButtonClassName
}: ModalProps) {
  const { t } = useTranslation()

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div 
        className="fixed inset-0 bg-black/50" 
        onClick={onClose}
      />
      <Card className="relative z-10 w-full max-w-md">
        <CardHeader>
          <CardTitle>{title}</CardTitle>
          {description && (
            <CardDescription className="whitespace-pre-line">
              {description}
            </CardDescription>
          )}
        </CardHeader>
        <CardContent className="space-y-4">
          {children}
          
          {(showCancelButton || actionButtonText) && (
            <div className="flex justify-end gap-2 pt-2">
              {actionButtonText && (
                <SaveButton
                  onClick={onAction || (() => {})}
                  isLoading={actionButtonLoading}
                  disabled={actionButtonDisabled || actionButtonLoading}
                  label={actionButtonText.includes('جاري') ? 'حفظ' : actionButtonText}
                  loadingText={actionButtonLoadingText || (actionButtonText.includes('جاري') ? actionButtonText : 'جاري الحفظ...')}
                  size="md"
                  className={actionButtonClassName}
                />
              )}
              
              {showCancelButton && (
                <Button
                  variant="outline"
                  size="sm"
                  onClick={onClose}
                  className={cancelButtonClassName || "border-gray-300 text-[#1E293B] hover:text-[#1E293B] hover:border-[#1E293B] hover:bg-gray-50 active:bg-gray-100"}
                >
                  {cancelButtonText || t('cancel') || 'Cancel'}
                </Button>
              )}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  )
}

